import React from 'react';

const Icon = ({ url, children, className, width, height }) => (
  <span className={className}>
    <img src={url} className="dib v-mid" width={width} height={height} />
    {children}
  </span>
)

Icon.defaultProps = {
  url: '/images/pop-like-icon.svg',
  className: '',
  width: '16px',
  height: '16px'
};

export default Icon;

